import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { ListView } from '@syncfusion/ej2-lists';
import { closest } from '@syncfusion/ej2-base';
import { DragAndDropEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, Query, ReturnOption, Predicate } from '@syncfusion/ej2-data';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
    //ngOnInit(): void {
        
    //}

  @ViewChild("inputObj_SLA", { static: false }) inputObj_SLA: ElementRef;
  @ViewChild("inputObj_KPI", { static: false }) inputObj_KPI: ElementRef;
  @ViewChild("inputObj_Tree", { static: false }) inputObj_Tree: ElementRef;

  @ViewChild('list',{ static: false })
  public list: ListView;
  loader: boolean = false;
  // Hierarchical data source for TreeView component

  public productTeam1: Object[] = [
    { id: 'y1', name: '2019', expanded: true, icon: 'year', type: 'year', hasChild: true },
    { id: 'q100', pid: 'y1', name: 'Q1', expanded: true, icon: 'quater', type: 'quater', hasChild: true },
    { id: 's200', pid: 'q100', name: 'Customer Based SLA 1', expanded: true, icon: 'sla', type: 'sla', hasChild: true },
    { id: 'k300', pid: 's200', icon: 'kpi', type: 'kpi', name: 'Operating Expenses Ratio' },
    { id: 's201', pid: 'q100', name: 'Customer Based SLA 2', icon: 'sla', type: 'sla', hasChild: true },
    { id: 'k301', pid: 's201', icon: 'kpi', type: 'kpi', name: 'Customer Acquisition Costs' },
    { id: 'y2', name: '2018', icon: 'year', type: 'year', expanded: true, hasChild: true },
    { id: 'q101', pid: 'y2', name: 'Q1', icon: 'quater', type: 'quater', expanded: true, hasChild: true },
    { id: 's201', pid: 'q101', name: 'Service Based SLA 3', icon: 'sla', type: 'sla', expanded: true, hasChild: true },
    { id: 'k301', pid: 's201', icon: 'kpi', type: 'kpi', name: 'Key Business Objectives' }             
  ];
  public field: Object = { dataSource: this.productTeam1, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', iconCss: 'icon'};
  // Allow multi selection
  public allowMultiSelection: boolean = true;
  // Allow drag and drop
  public allowDragAndDrop: boolean = true;
  public slaList_bind: Object[];
  public slaList: Object[] = [
    {
      id: 's3', name: 'Service Based SLA 1', icon: 'sla', type: 'sla'
    },
    {
      id: 's4', name: 'Customer Based SLA 1', icon: 'sla', type: 'sla'
    },
    {
      id: 's5', name: 'Hierarchical SLA 1', icon: 'sla', type: 'sla'
    },
    {
      id: 's6', name: 'Service Based SLA 4', icon: 'sla', type: 'sla'
    },
    {
      id: 's7', name: 'Customer Based SLA 2', icon: 'sla', type: 'sla'
    },
    {
      id: 's8', name: 'Service Based SLA 3', icon: 'sla', type: 'sla'
    },
    {
      id: 's9', name: 'Customer Based SLA 3', icon: 'sla', type: 'sla'
    },
    {
      id: 's10', name: 'Hierarchical SLA 2', icon: 'sla', type: 'sla'
    },
    {
      id: 's11', name: 'Service Based SLA 2', icon: 'sla', type: 'sla'
    },
    {
      id: 's12', name: 'Customer Based SLA 4', icon: 'sla', type: 'sla'
    },
    {
      id: 's13', name: 'Hierarchical SLA 2', icon: 'sla', type: 'sla'
    },
    {
      id: 's14', name: 'Customer Based SLA 5', icon: 'sla', type: 'sla'
    },
    {
      id: 's15', name: 'Hierarchical SLA 6', icon: 'sla', type: 'sla'
    },
    {
      id: 's16', name: 'Service Based SLA 7', icon: 'sla', type: 'sla'
    },
    {
      id: 's17', name: 'Customer Based SLA 3', icon: 'sla', type: 'sla'
    },
    {
      id: 's18', name: 'Hierarchical SLA 4', icon: 'sla', type: 'sla'
    },
    {
      id: 's19', name: 'Customer Based SLA 9', icon: 'sla', type: 'sla'
    }
  ];

  public kpiList: Object[] = [
    {
      id: 'k3', name: 'Customer Acquisition Costs', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k4', name: 'Customer Lifetime Value', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k5', name: 'Sales Target', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k6', name: 'Operating Expenses Ratio', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k7', name: 'Customer Acquisition Costs', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k8', name: 'Key Business Objectives', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k9', name: 'KPI Test1', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k10', name: 'KPI Test2', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k11', name: 'KPI Test3', icon: 'kpi', type: 'kpi'
    },
    {
      id: 'k12', name: 'KPI Test4', icon: 'kpi', type: 'kpi'
    }
  ];

  // Mapping TreeView fields property with data source properties
  public fields_sla: Object = { dataSource: this.slaList, id: 'id', text: 'name', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };
  public fields_kpi: Object = { dataSource: this.kpiList, id: 'id', text: 'name', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };
  public fields_sla_temp: Object = this.fields_sla;
  public fields_kpi_temp: Object = this.fields_kpi;
  public checkNodes: Object[] = [];
  // Allow multi selection
  public allowMultiSelections: boolean = true;
  // Allow drag and drop
  public allowDragAndDrops: boolean = true;
  public id: number = 1;
  constructor() { }

  ngOnInit() {
   
  }
 
  public onDragStop(args: any): void {

    this.loader = true;
    
    let targetEle: any = closest(args.target, '.e-droppable');
    targetEle = targetEle ? targetEle : args.target;
    // Check the target as ListView or not
    if (targetEle && targetEle.classList.contains('custom-list')) {
      args.cancel = true;
      let newData: { [key: string]: Object }[] = [];
      if (args.draggedNode.classList.contains('e-active')) {
        var dragNode: any = closest(args.draggedNode, '.e-treeview');
        var selNodes = dragNode.ej2_instances[0].selectedNodes;
        for (let i: number = 0, len: number = selNodes.length; i < len; i++) {
          let nodeEle: Element = document.querySelector('[data-uid="' + selNodes[i] + '"]').querySelector('.e-list-text');
          let nodeText: string = nodeEle.textContent;
          let newNode: { [key: string]: Object } = { id: 'l' + this.id, text: nodeText, class: 'custom-delete', iconId: 'i' + this.id };
          this.id++;
          newData.push(newNode);
        }
      } else {
        let text: string = 'text';
        let nodeText: string = args.draggedNodeData[text] as string;
        let newNode: { [key: string]: Object } = { id: 'l' + this.id, text: nodeText, class: 'custom-delete', iconId: 'i' + this.id };
        this.id++;
        newData.push(newNode);
      }
      // Add collection of node to ListView
      var listObj = this.list;
      listObj.addItem(newData, undefined);


     
    }

    
  }

  
  public nodeDrag(args: DragAndDropEventArgs): void {

    if (args.draggedNodeData.id.toString().indexOf("y") > -1) {
      args.dropIndicator = 'e-no-drop';
    }
    if (args.draggedNodeData.id.toString().indexOf("q") > -1) {
      if (args.droppedNodeData.id.toString().indexOf("y") === -1) {
        args.dropIndicator = 'e-no-drop';
      }
      else {
        //args.cancel = false;
      }
    }
    if (args.draggedNodeData.id.toString().indexOf("s") > -1) {
      if (args.droppedNodeData.id.toString().indexOf("q") === -1) {
        args.dropIndicator = 'e-no-drop';
      }
      else {
       // args.cancel = false;
      }
      
    }
    if (args.draggedNodeData.id.toString().indexOf("k") > -1) {
      if (args.droppedNodeData.id.toString().indexOf("s") === -1) {
        args.dropIndicator = 'e-no-drop';
      }
      else {
       // args.cancel = false;
      }
    
    }
  }

  public dragStop(args: DragAndDropEventArgs): void {
    
    this.loader = true;
   // if (args.droppedNode.getElementsByClassName('year').length === 0) args.cancel = true;
    if (args.draggedNodeData.id.toString().indexOf("y") > -1) {
      args.cancel = true;
    }
    if (args.draggedNodeData.id.toString().indexOf("q") > -1) {
      if (args.droppedNodeData.id.toString().indexOf("y") === -1) {
        args.cancel = true;
      }
      else {
        args.cancel = false;
      }
    }
    if (args.draggedNodeData.id.toString().indexOf("s") > -1) {
      if (args.droppedNodeData.id.toString().indexOf("q") === -1) {
        args.cancel = true;
      }
      else {
        args.cancel = false;
      }
      this.dragStoprebind_SLA();
    }
    if (args.draggedNodeData.id.toString().indexOf("k") > -1) {
      if (args.droppedNodeData.id.toString().indexOf("s") === -1) {
        args.cancel = true;
      }
      else {
        args.cancel = false;
      }
      this.dragStoprebind_KPI();
    }
    setTimeout(() => {    //<<<---    using ()=> syntax
      this.loader = false;
    }, 300);
  }

   dragStoprebind_SLA() {
    let predicats = [], _array = [], _filter = [];
    for (var j = 0; j < this.slaList.length; j++) {
      _filter.push(this.slaList[j]["id"]);
      var filters = this.getFilterItems(this.slaList[j], this.slaList);
      for (var i = 0; i < filters.length; i++) {
        if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
          _array.push(filters[i]);
          predicats.push(new Predicate('id', 'equal', filters[i], false));
        }
      }
    }
    let query = new Query().where(Predicate.or(predicats));
    let newList = new DataManager(this.slaList).executeLocal(query);
    this.changeDataSource_SLA(newList);        
   }
  dragStoprebind_KPI() {
    let predicats = [], _array = [], _filter = [];
    for (var j = 0; j < this.kpiList.length; j++) {
      _filter.push(this.kpiList[j]["id"]);
      var filters = this.getFilterItems(this.kpiList[j], this.kpiList);
      for (var i = 0; i < filters.length; i++) {
        if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
          _array.push(filters[i]);
          predicats.push(new Predicate('id', 'equal', filters[i], false));
        }
      }
    }
    let query = new Query().where(Predicate.or(predicats));
    let newList = new DataManager(this.kpiList).executeLocal(query);
    this.changeDataSource_KPI(newList);
  }
  //Search

  changeDataSource_SLA(data) {     
    this.fields_sla = { dataSource: data, id: 'id', text: 'name', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };
  }
  //Filtering the TreeNodes
  searchNodes_SLA() {
    
    let _text = this.inputObj_SLA.nativeElement.value;
    let predicats = [], _array = [], _filter = [];
    if (_text == "") {
      this.changeDataSource_SLA(this.slaList);      
    }
    else {
      let predicate = new Predicate('name', 'contains', _text, true);
      let filteredList = new DataManager(this.slaList).executeLocal(new Query().where(predicate));
      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["id"]);
        var filters = this.getFilterItems(filteredList[j], this.slaList);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('id', 'equal', filters[i], false));
          }
        }
      }
      if (predicats.length == 0) {
        this.changeDataSource_SLA([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.slaList).executeLocal(query);
        this.changeDataSource_SLA(newList);        
        
      }
    }
  }

  changeDataSource_KPI(data) {
    this.fields_kpi = { dataSource: data, id: 'id', text: 'name', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };
  }

  searchNodes_KPI() {

    
    let _text = this.inputObj_KPI.nativeElement.value;
     
    let predicats = [], _array = [], _filter = [];
    if (_text == "") {
      this.changeDataSource_KPI(this.kpiList);
    }
    else {
      let predicate = new Predicate('name', 'contains', _text, true);
      let filteredList = new DataManager(this.kpiList).executeLocal(new Query().where(predicate));    
      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["id"]);
        var filters = this.getFilterItems(filteredList[j], this.kpiList);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('id', 'equal', filters[i], false));
          }
        }
      }
      if (predicats.length == 0) {
        this.changeDataSource_KPI([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.kpiList).executeLocal(query);
        this.changeDataSource_KPI(newList);

      }
    }
  }

  changeDataSource_Tree(data) {
    this.field = { dataSource: data, id: 'id', text: 'name', child: 'child', iconCss: 'icon' };
  }
  //Filtering the TreeNodes
  searchNodes_Tree() {
    
    let _text = this.inputObj_Tree.nativeElement.value;
     
    let predicats = [], _array = [], _filter = [];
    if (_text == "") {
      this.changeDataSource_Tree(this.productTeam1);
    }
    else {
      let predicate = new Predicate('name', 'contains', _text, true);
      let filteredList = new DataManager(this.productTeam1).executeLocal(new Query().where(predicate));
     
      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["id"]);
        var filters = this.getFilterItems(filteredList[j], this.productTeam1);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('id', 'equal', filters[i], false));
          }
        }
      }
      if (predicats.length == 0) {
        this.changeDataSource_Tree([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.productTeam1).executeLocal(query);
        this.changeDataSource_Tree(newList);

      }
    }
  }

  //Find the Parent Nodes for corresponding childs
  getFilterItems(fList, list) {
    
    let nodes = [];
    nodes.push(fList["id"]);
    let query2 = new Query().where('id', 'equal', fList["pid"], false);
    let fList1 = new DataManager(list).executeLocal(query2);
    if (fList1.length != 0) {
      let pNode = this.getFilterItems(fList1[0], list);
      for (var i = 0; i < pNode.length; i++) {
        if (nodes.indexOf(pNode[i]) == -1 && pNode[i] != null)
          nodes.push(pNode[i]);
      }
      return nodes;
    }
    return nodes;
  }



}
